import { INSTANCE, INSTANCELIST } from './API'

const getTagName = (name) =>
    typeof name === 'string' ? name : name?.en || name?.zh || ''

const sortByName = (results) => {
    results?.list?.sort(function (a, b) {
        const nameA = getTagName(a?.name).toLowerCase()
        const nameB = getTagName(b?.name).toLowerCase()
        if (nameA > nameB) return 1
        if (nameA < nameB) return -1
        return 0
    })
    return results
}

export const getProductTags = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { sort, range, filter, token } = queryKey[1]

        const params = {}
        if (sort) params.sort = JSON.stringify(sort)
        if (range) params.range = JSON.stringify(range)
        if (filter && Object.keys(filter).length) {
            params.filter = JSON.stringify(filter)
        }

        INSTANCELIST({
            method: 'get',
            url: '/product-tags',
            headers: {
                Authorization: `Bearer ${token}`,
            },
            params,
        })
            .then(sortByName)
            .then(resolve)
            .catch(reject)
    })

export const getProductTagsList = (token) =>
    new Promise((resolve, reject) => {
        INSTANCELIST({
            method: 'get',
            url: '/product-tags',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(sortByName)
            .then(resolve)
            .catch(reject)
    })

export const getSingleProductTag = ({ queryKey }) =>
    new Promise((resolve, reject) => {
        const { tagId, token } = queryKey[1]

        INSTANCE({
            method: 'get',
            url: `/product-tags/${tagId}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(resolve)
            .catch(reject)
    })

export const CreateProductTag = (form, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'post',
            url: '/product-tags',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })

export const EditProductTag = (form, token, tagId) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'put',
            url: `/product-tags/${tagId}`,
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
            data: JSON.stringify(form),
        })
            .then(resolve)
            .catch(reject)
    })

export const DeleteProductTag = (tagId, token) =>
    new Promise((resolve, reject) => {
        INSTANCE({
            method: 'delete',
            url: `/product-tags/${tagId}`,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        })
            .then(resolve)
            .catch(reject)
    })
